import script from "./DocumentsSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentsSection.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentsSection.vue?vue&type=style&index=0&id=c4e06b08&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4e06b08"]])

export default __exports__